import React, { FC, useEffect, useState } from 'react';

import { NativeResources } from '@ariksa/inventory-core/api';
import { Box, Stack } from '@chakra-ui/react';
import { find } from 'lodash';
import map from 'lodash/map';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'components/DataEntry';
import { useAllowListContext } from 'containers/Inventory/AllowList/context';
import { selectAllowList } from 'containers/Inventory/AllowList/selector';
import { actions } from 'containers/Inventory/AllowList/slice';

import { toTitleCase } from '../../../../../../../../utils/string';

interface Props {}

export const StatusComponent: FC<Props> = () => {
  const { formData, allowListStatus } = useSelector(selectAllowList);
  const { updateFormData, hasEC2Criteria } = useAllowListContext();
  const dispatch = useDispatch();

  const [status, setStatus] = useState<Record<string, any>>({});
  const [statusOptions, setStatusOptions] = useState<Record<string, any>[]>([]);

  useEffect(() => {
    const payload = hasEC2Criteria
      ? { resourceType: NativeResources.Ec2Instance }
      : {};
    dispatch(actions.getAllowListStatus({ q: payload }));
  }, [dispatch, hasEC2Criteria]);

  useEffect(() => {
    setStatusOptions(
      map(allowListStatus.data, o => ({ label: toTitleCase(o), value: o })),
    );
  }, [allowListStatus.data]);

  useEffect(() => {
    setStatus(
      find(statusOptions, o => o?.value === formData.status) ??
        statusOptions[0],
    );
  }, [formData.status, statusOptions]);

  return (
    <Stack isInline w="full">
      <Box whiteSpace="nowrap" pt={1}>
        Allow list status is
      </Box>
      <Box minW={64}>
        <Select
          options={statusOptions}
          value={status}
          isLoading={allowListStatus.isLoading}
          onChange={selected => {
            setStatus(selected);
            updateFormData('status', selected);
          }}
        />
      </Box>
    </Stack>
  );
};
